function holdDownloadAndSendEmail(status) {
  // 'PaidOver2': 5, 'PaidOver3': 6, 'Hold': 7,
  return [5, 6, 7].includes(status)
}

export default {holdDownloadAndSendEmail}
